import UniversalSearch from "./UniversalSearch";

export default UniversalSearch 